export default {
    isEmpty: state => {
        return state.hubs.length === 0;
    }
};